// fslint-disable unitTests
import { useFonts } from '@feeditback/fib-components';
import { Chart } from 'chart.js';

// Force chart pixel ratio so graphs don't resize on multi-monitor setups
Chart.defaults.devicePixelRatio = 1;

// Default font family
Chart.defaults.font.family = useFonts().fontFamilies.value['primary'];
